import { AutogenModelArControl, AutogenRowArControl } from "./autogen/AutogenModelArControl";

export class ModelArControl extends AutogenModelArControl<RowArControl> {
	constructor() {
		super(RowArControl);
	}
}

export class RowArControl extends AutogenRowArControl {
}